export const TOUR_TARGET_ATTRIBUTE = "data-tour";

// Elements a tour can anchor to. Values are rendered as data-tour attributes,
// so renaming one means updating the markup that carries it.
export const TOUR_TARGETS = {
   PROGRESS_BAR: "progress-bar",
   CASE_BASICS: "case-basics",
   CASE_PLAINTIFFS: "case-plaintiffs",
   CASE_DEFENDANTS: "case-defendants",
   IMPORT_PARTNER: "import-partner",
   LIABILITY_NARRATIVE: "liability-narrative",
   LIABILITY_REPORTS: "liability-reports",
   MEDICAL_PROVIDERS_POST: "medical-providers-post",
   MEDICAL_PROVIDERS_PRIOR: "medical-providers-prior",
   MEDICAL_SUMMARY: "medical-summary",
   PAIN_POINTS: "pain-points",
   INJURY_PHOTOS: "injury-photos",
   ECONOMIC_DAMAGES: "economic-damages",
   GENERATE_DEMAND: "generate-demand",
   CASE_LIST_SAMPLE_ROW: "case-list-sample-row",
   CASE_LIST_SAMPLE_STATUS: "case-list-sample-status",
   CASE_LIST_SAMPLE_ACTIONS: "case-list-sample-actions",
   CASE_LIST_SEARCH: "case-list-search",
   CASE_LIST_MY_CASES: "case-list-my-cases",
   CASE_LIST_ADD_CASE: "case-list-add-case",
   DEMAND_STUDIO_VIEW_TOGGLE: "demand-studio-view-toggle",
   DEMAND_STUDIO_TABS: "demand-studio-tabs",
   DEMAND_STUDIO_DOCUMENT: "demand-studio-document",
   DEMAND_STUDIO_COMMENTS: "demand-studio-comments",
   DEMAND_STUDIO_TOOLS: "demand-studio-tools",
   DEMAND_STUDIO_PREVIEW: "demand-studio-preview",
   DEMAND_STUDIO_SAVE: "demand-studio-save",
   EASY_MODE_STEPPER: "easy-mode-stepper",
   EASY_MODE_CASE_FACTS: "easy-mode-case-facts",
   EASY_MODE_CLASSIC_INTAKE: "easy-mode-classic-intake",
   EASY_MODE_PARTNER_IMPORT: "easy-mode-partner-import",
   EASY_MODE_DROPZONE: "easy-mode-dropzone",
   EASY_MODE_UPLOAD_LIST: "easy-mode-upload-list",
   EASY_MODE_CONTEXT: "easy-mode-context",
   EASY_MODE_GENERATE: "easy-mode-generate",
};

export const tourSelector = (target) => `[${TOUR_TARGET_ATTRIBUTE}="${target}"]`;
